import { GraduationCap, Trophy, HeartHandshake, BookOpen } from 'lucide-react';
import Box from '../../components/Box';
import { MarktingCard } from '../../AvatarDigitalMarketer/AiMarketingTeam';

export default function MeetYourAiTeachingTeam() {
  const teamMembers = [
    {
      icon: <GraduationCap className="w-6 h-6" />,
      iconBg: "bg-indigo-100",
      iconColor: "text-indigo-600",
      title: "SuperStudent",
      description: "Daily 2‑min inspiration: stories of achievers that build optimism, self-belief, and resilience.",
      footer: "Inspired by Dweck & Bandura",
    },
    {
      icon: <Trophy className="w-6 h-6" />,
      iconBg: "bg-indigo-100",
      iconColor: "text-indigo-600",
      title: "1st Rank (Exam Calm)",
      description: "Adaptive practice + feedback mapped to each child's zone of proximal development to remove exam fear.",
      footer: "Built on Vygotsky's ZPD",
    },
    {
      icon: <HeartHandshake className="w-6 h-6" />,
      iconBg: "bg-indigo-100",
      iconColor: "text-indigo-600",
      title: "Parent Helpdesk",
      description: "Evidence-based answers via short videos and podcasts for focus, habits, and emotions.",
      footer: "Goleman & Bowlby"
    },
    {
      icon: <BookOpen className="w-6 h-6" />,
      iconBg: "bg-indigo-100",
      iconColor: "text-indigo-600",
      title: "Child Care Expert",
      description: "44+ micro‑podcasts that help parents prevent behavioural challenges before they begin.",
      footer: "Erikson & Piaget"
    }
  ];

  return (
    <>
      <Box
        badge={"YOUR TEACHING TEAM"}
        title={"Meet Your AI Teaching Team"}
        description={"A psychological ecosystem that trains the heart behind the mind."}
        leftBlock={teamMembers.slice(0, 2).map((member, index) => <MarktingCard key={"memberUpperCardTeaching" + index} member={member} />)}
        rightBlock={teamMembers.slice(2).map((member, index) => <MarktingCard key={"memberUpperCardTeaching" + index} member={member} />)}
      />

    </>
  );
}